import { useAnimation, motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
const ExtraSection1 = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: false,
    threshold: 0.2, 
  });
  
  useEffect(() => {
    if (inView) {
      controls.start('visible');
    } else {
      controls.start('hidden');
    }
  }, [controls, inView]);
  return (
      <section className=' py-[60px] md:py-[140px] bg-[#2937B1] '>
          <motion.div   ref={ref}
        initial="hidden"
        animate={controls}
       className='max-w-[1170px] mx-auto card-body px-5 '
        transition={{ duration: 0.2 }} >
            <div className="hero ">
                  
    <div className="hero-content flex-col   p-0 gap-y-[10px]  md:gap-x-12  lg:flex-row-reverse ">
      <motion.div   transition={{ duration: 0.5 ,delay:0.2}} variants={{
          visible: { opacity: 1, x: 0 },
          hidden: { opacity: 0, x: 90 },
        }}> <img src="https://i.ibb.co/BT86f6J/image1-png.png"  alt=''/></motion.div>
      <motion.div transition={{ duration: 0.5 ,delay:0.2}}  variants={{
          visible: { opacity: 1, x: 0 },
          hidden: { opacity: 0, x: -100 },
        }} className=''>    
        <h2 className=' text-start text-[30px] leading-[40px]  md:text-[44px] md:leading-[54px] font-bold mb-5 text-[#FFF]' >High Quality Pistion</h2>      
           <p className='text-[18px] leading-[30px]   text-start max-w-[600px] text-[#FFF]'>When it comes to the heart of your engine, nothing is more crucial than the pistons. High quality pistons are essential for maintaining optimal engine performance and ensuring long-term reliability. At our store, we provide the best car parts, including top-of-the-line pistons that are designed to withstand the rigors of high-performance driving and everyday use.
           </p>
     </motion.div>
     </div>
    </div>
        </motion.div>
      </section>
    );
};

export default ExtraSection1;